import React from "react";
import "./App.css";
import { NavLink } from "react-router-dom";
import "bootstrap/dist/css/bootstrap.min.css";
import "./Home.scss";
import { MDBContainer, MDBRow } from "mdbreact";
import { BrowserRouter as Router} from "react-router-dom";
import constants from "./common/restService/constant";
import GatewayGet from "./common/restService/GatewayGet";

import $, { event } from "jquery";

class Home extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      userName: "",
      displayName: "",
      roleList: "",
      ncrmRoles: false,
      crmRoles: false,
      mdRoles: false,
      ltsRoles: false,
      eventManagementRole: false,
      ncrmHome: "Home",
      crmEnvLink: "",
    };
  }

  async componentDidMount() {
    //for 403 error //Zubin
    sessionStorage.removeItem("sessionTimeout");
    sessionStorage.removeItem("internalServerError");

    if (this.state.ncrmHome == "Home") {
      $("#mySidepanel.sidepanel").removeClass("active");
      $("#custom-move-Menu").css("margin-left", "0px");
      $("#mySidepanel,#sidebarCollapse").hide();
    } else {
      $(
        "#sidebarCollapse,#mySidepanel,#content #custom-move-Menu.custom-move"
      ).show();
    }

    let props = {};
    let inputObj = {};
    props["query"] = constants.serviceRoot;
    props["headers"] = constants.serviceHeaders;
    inputObj["Activity"] = "GET_USER_DETAILS";
    inputObj["Input"] = "";
    props.input = inputObj;
    let userprofileRes = await GatewayGet(props, props.input);
    if(userprofileRes != undefined){
      let userprofile = userprofileRes['RESULT'];
      if(userprofile){
        console.log("inside", userprofile);
        this.state.userName = userprofile["FIRST_NAME"] + " " + userprofile["LAST_NAME"];
        this.state.roleList = userprofile["ROLE_LIST"];
        this.state.displayName = this.toTitleCase(this.state.userName);
        if (
          this.state.roleList["BB"] === "True" ||
          this.state.roleList["CW"] === "True" ||
          this.state.roleList["CARRIER"] === "True" ||
          this.state.roleList["APPROVER"] === "True" ||
          this.state.roleList["MDADMIN"] === "True" ||
          this.state.roleList["MDVIEWER"] === "True" ||
          this.state.roleList["MDPREQUAL"] === "True"
        ) {
          this.state.ncrmRoles = true;
        }
        if (
          this.state.roleList["FFRATEADMIN"] === "True" ||
          this.state.roleList["FFRATELOADER"] === "True" ||
          this.state.roleList["FFRATEVIEWER"] === "True" ||
          this.state.roleList["INTEGRRATEADMIN"] === "True" ||
          this.state.roleList["INTEGRRATELOADER"] === "True" ||
          this.state.roleList["INTEGRRATEVIEWER"] === "True" ||
          this.state.roleList["MDADMINCRM"] === "True" ||
          this.state.roleList["MDVIEWERCRM"] === "True"
        ) {
          this.state.crmRoles = true;
        }
        if (
          this.state.roleList["MDADMIN"] === "True" ||
          this.state.roleList["MDADMINCRM"] === "True" ||
          this.state.roleList["MDVIEWER"] === "True" ||
          this.state.roleList["MDVIEWERCRM"] === "True"
        ) {
          this.state.mdRoles = true;
        }
        if (
          this.state.roleList["INTEGRRATEADMIN"] === "True" ||
          this.state.roleList["FFRATEADMIN"] === "True"
        ) {
          this.state.ltsRoles = true;
        }
        if (
          this.state.roleList.XDMAWBETA["BB"] === "True" ||
          this.state.roleList.XDMAWBETA["CAR"] === "True" ||
          this.state.roleList.XDMAWBETA["GB"] === "True"
        ) {
          this.state.eventManagementRole = true;
        }
        this.setState({
          displayName: this.toTitleCase(this.state.userName),
        });
      }
    }
  }

  crmLink() {
    let crmUrl = window.location.href.toLowerCase().includes("localhost")
      ? "https://TMSReactApp.apps1-fm-int.icloud.intel.com"
      : window.location.href
          .toLowerCase()
          .includes("https://ncrmdev.apps1-fm-int.icloud.intel.com")
      ? "https://TMSReactApp.apps1-fm-int.icloud.intel.com"
      : window.location.href
          .toLowerCase()
          .includes("https://tmsconsint.apps1-fm-int.icloud.intel.com")
      ? "https://CRMConsInt.apps1-fm-int.icloud.intel.com"
      : window.location.href
          .toLowerCase()
          .includes("https://transportationcons.intel.com")
      ? "https://CRMConsInt.apps1-fm-int.icloud.intel.com"
      : window.location.href
          .toLowerCase()
          .includes("https://transportation.intel.com")
      ? "https://crmint.apps1-fm-int.icloud.intel.com"
      : "";
    this.setState({ crmEnvLink: crmUrl });
  }

  ltsLink() {
    let ltsUrl = window.location.href.toLowerCase().includes("localhost")
      ? "https://transportation-alloc-dev.apps1-fm-int.icloud.intel.com/"
      : window.location.href
          .toLowerCase()
          .includes("https://ncrmdev.apps1-fm-int.icloud.intel.com")
      ? "https://transportation-alloc-dev.apps1-fm-int.icloud.intel.com/"
      : window.location.href
          .toLowerCase()
          .includes("https://tmsconsint.apps1-fm-int.icloud.intel.com")
      ? "https://transportation-alloc-cons.apps1-fm-int.icloud.intel.com/"
      : window.location.href
          .toLowerCase()
          .includes("https://transportationcons.intel.com")
      ? "https://transportation-alloc-cons.apps1-fm-int.icloud.intel.com/"
      : window.location.href
          .toLowerCase()
          .includes("https://transportation.intel.com")
      ? "https://transportation-alloc.apps1-fm-int.icloud.intel.com/"
      : "";
    this.setState({ ltsEnvLink: ltsUrl });
  }

  eventManagementLink() {
    console.log(window.history);
  }

  toTitleCase = function (str) {
    str = str.toLowerCase().split(" ");
    for (var i = 0; i < str.length; i++) {
      str[i] = str[i].charAt(0).toUpperCase() + str[i].slice(1);
    }
    return str.join(" ");
  };

  checkAndClearData() {
    window.location.href = "/NCRMHome";
  }

  homeNav() {
    window.location.href = "/";
  }
  
  render() {
    return (
      <>
        <nav
          className="navbar navbar-expand-sm"
          style={{ backgroundColor: "#0068B5",width: "100%",paddingTop: "3vh" }}
        >
          <div className="collapse navbar-collapse" id="navbarSupportedContent">
            <ul
              className="navbar-nav mr-auto menus"
              style={{ margin: "0px 45px" }}
            >
              <li className="nav-item">
                <NavLink
                  to="/"
                  activeclassname="active"
                  className="nav-link"
                  onClick={() => this.homeNav()}
                >
                  <p> HOME </p>
                </NavLink>
              </li>
              {/* {!this.state.roleList['APPROVER'] &&  */}

              {this.state.ncrmRoles && (
                <li className="nav-item">
                  <NavLink
                    exact
                    to="/NCRMHome"
                    activeclassname="active"
                    className="nav-link"
                    onClick={() => this.checkAndClearData()}
                  >
                    <p>NCRM</p>
                  </NavLink>
                </li>
              )}
              {/* {this.state.crmRoles && (
                <li className="nav-item">
                  <a
                    // href="https://CRMConsInt.apps1-fm-int.icloud.intel.com"
                    href={this.state.crmEnvLink}
                    activeclassname="active"
                    className="nav-link"
                    onClick={this.crmLink.bind(this)}
                  >
                    <p>CRM</p>
                  </a>
                </li>
              )} */}
              {/* <li className="nav-item">
                    <NavLink
                      to="/Profile"
                      activeclassname="active"
                      className="nav-link"
                    //   onClick={() => this.checkAndClearData("Profile")}
                    >
                      Carrier Master
                    </NavLink>
                  </li> */}

              {this.state.ltsRoles && (
                <li className="nav-item">
                  <a
                    // href="https://CRMConsInt.apps1-fm-int.icloud.intel.com"
                    href={this.state.ltsEnvLink}
                    activeclassname="active"
                    className="nav-link"
                    onClick={this.ltsLink.bind(this)}
                  >
                    <p> Allocation </p>
                  </a>
                </li>
              )}
              {this.state.eventManagementRole && (
                <li className="nav-item">
                  <a
                    // href="https://CRMConsInt.apps1-fm-int.icloud.intel.com"
                    // window.location.href.concat("FgCrossDock")
                    href={window.location.href.concat("FgCrossDock")}
                    activeclassname="active"
                    className="nav-link"
                    // onClick={this.eventManagementLink.bind(this)}
                  >
                    <p> Event Management </p>
                  </a>
                </li>
              )}
            </ul>
          </div>
        </nav>

        <MDBContainer fluid className="bg">
          <MDBRow>
            {/* {this.state.ncrmRoles &&    <MDBCol md="2"><img src={iconImage}></img><label>NCRM</label></MDBCol> } */}
          </MDBRow>
          <MDBRow>
            {/* {this.state.crmRoles &&  <MDBCol md="2"><a style={{color:"white"}} href="https://tmsreactapp.apps1-fm-int.icloud.intel.com/"><img src={iconImage}></img><label>Rates Management</label></a></MDBCol>} */}
          </MDBRow>
          <MDBRow>
            {/* {this.state.mdRoles &&  <MDBCol md="2"><a><img src={iconImage}></img><label>Carrier Master</label></a></MDBCol>} */}
          </MDBRow>
          <MDBRow>
            {/* <MDBCol md="2"><img src={iconImage}></img><label>LTS</label></MDBCol> */}
          </MDBRow>
        </MDBContainer>
        {/* <Footer></Footer> */}
        </>
    );
  }
}

export default Home;
